import React from 'react';
import {Input, Select, Form, Modal, DatePicker} from 'antd';
import moment from 'moment';



const formItemLayout = {
  labelCol: {
    span: 6,
  },
  wrapperCol: {
    span: 14,
  },
}

const formLargeItemLayout = {
  labelCol: {
    span: 3,
  },
  wrapperCol: {
    span: 19,
  },
}

const modalMaster = ({visible,type,item = {},onOk,onCancel,form: {getFieldDecorator,validateFields,getFieldsValue,
	},}) => {

	function handleOk () {
		validateFields((err, values) => {
		if(err){return }
		
	  //如果是 Select InputNumber 作为输入组件；如果不填返回的是 undefined，应该变成 null
      //if(values.cid == item.cid){delete values.cid; } else {if(typeof(values.cid)=="undefined"){values.cid = null; }}	  


		
		if (Object.getOwnPropertyNames(values).length == 0) {
		  onCancel()
		  return
		}
	  
	  if(item.id){values.id = item.id} //如果是变更，item有内容，把id给到values

		onOk(values)      

	  })
	}

	const modalOpts = {
	  title: `${type === 'create' ? '新建' : '修改'}`,
	  visible,
	  onOk: handleOk,
	  onCancel,keyboard:false,maskClosable:false,
	  wrapClassName: 'vertical-center-modal',
	  width: 520,
	  //okText: '确认',
      //cancelText: '取消',
	}



	return (
	  <Modal {...modalOpts}>
		<Form layout="horizontal">
		
		<Form.Item label={'用户名'} {...formItemLayout} >
		   {getFieldDecorator('user_name', {
				initialValue: item?.m_clientLegalPerson?.[0]?.user_name,
				rules: [{ required: true, message: 'Please input your user_name!' }],
			  }
			)(
			<Input disabled={type != 'create'} />   
			)}
		</Form.Item>         
		<Form.Item label={'客户名称'} {...formItemLayout} >
		   {getFieldDecorator('cust_name', {
				initialValue: item.cust_name,
			  }
			)(
			<Input disabled={type != 'create'}/>   
			)}
		</Form.Item>         
		<Form.Item label={'授信日期'} {...formItemLayout} >
		   {getFieldDecorator('audit_time', {
				initialValue: moment(item.audit_time,'YYYYMMDD'),
			  }
			)(
			<DatePicker />
			)}
		</Form.Item>
			<Form.Item label={'到期时间'} {...formItemLayout} >
				{getFieldDecorator('finished_at', {
						initialValue: moment(item.finished_at,'YYYYMMDD'),
					}
				)(
					<DatePicker />
				)}
			</Form.Item>
			<Form.Item label={'授信金额'} {...formItemLayout} >
		   {getFieldDecorator('loan_credit', {
				initialValue: item.loan_credit,
			  }
			)(
			<Input  />   
			)}
		</Form.Item>         
		<Form.Item label={'金融产品'} {...formItemLayout} >
		   {getFieldDecorator('loan_product', {
				initialValue: item.loan_product,
			  }
			)(
			<Input  />
			)}
		</Form.Item>
		<Form.Item label={'SAP编码'} {...formItemLayout} >
		   {getFieldDecorator('sap_no', {
				initialValue: item.sap_no,    
			  }
			)(
			<Input  />   
			)}
		</Form.Item>
			<Form.Item label={'集团归属'} {...formItemLayout} >
				{getFieldDecorator('groups', {
						initialValue: item.groups,
					}
				)(
					<Select  mode="multiple" placeholder="选择集团归属" style={{ width: '100%' }} >
						<Select.Option key='1' value={'dj'}>大经</Select.Option>
						<Select.Option key='2' value={'ytg'}>优特钢</Select.Option>
					</Select>
				)}
			</Form.Item>
		</Form>
	  </Modal>
	)
}


const ModalRender = Form.create()(modalMaster); 


export default ModalRender;
